import DomainCommon from './common';

const UseRecordService = {

    getBasicSettings: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/useRecord/basicSetting`,
                resolve, reject
            });
        });
    },
    updateBasicSetting: (setting) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchPut({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/useRecord/basicSetting`,
                jsonBody: setting,
                resolve, reject
            });
        });
    },
    list: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/useRecord`,
                resolve, reject
            });
        });
    },
    listUseRecordByUserId: (userId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/user/${userId}/useRecord`,
                resolve, reject
            });
        });
    },
    listUseRecordByGroupId: (groupId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/group/${groupId}/useRecord`,
                resolve, reject
            });
        });
    },
    listUseRecordByCompanyId: (companyId) => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/company/${companyId}/useRecord`,
                resolve, reject
            });
        });
    },
    getRankingData: () => {
        return new Promise((resolve, reject) => {
            return DomainCommon.fetchGet({
                url: `${DomainCommon.getUecareApiUrl()}/ui/callCenter/useRecord/rankingData`,
                resolve, reject
            });
        });
    }
};

export default UseRecordService;



// WEBPACK FOOTER //
// ./src/service/useRecord.js